import { render } from "./upload_files_public.vue?vue&type=template&id=050cd656"
import script from "./upload_files_public.vue?vue&type=script&lang=js"
export * from "./upload_files_public.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__